import type { MetaFunction } from "react-router";

import { mdxComponents } from "@/ui/mdx-components";

import { Frontmatter, type LegalFrontmatter } from "./frontmatter";
import MDXContent, { frontmatter } from "./privacy.mdx";

export const meta: MetaFunction = () => {
  const legalFrontmatter = frontmatter as LegalFrontmatter;
  return [{ title: `${legalFrontmatter.title} | ${publicEnv.siteTitle}` }];
};

export default function Privacy() {
  const legalFrontmatter = frontmatter as LegalFrontmatter;

  return (
    <article>
      <Frontmatter frontmatter={legalFrontmatter} />
      <MDXContent components={mdxComponents} />
    </article>
  );
}
